const BASE_URL = process.env.REACT_APP_API_URL;

export const getImageUrl = (path) => {
  if (!path) return "";

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const cleanPath = path.replace(/\\/g, "/").replace(/^\/+/, "");

  return `${BASE_URL}/${cleanPath}`;
};


